import type { WebsocketProvider } from 'y-websocket';
import type * as Y from 'yjs';
import type { WebsocketAwarenessState } from '../hooks/useWebsocket/websocket';

import { createContext } from 'react';

interface WebsocketContextProps {
  yjsDocument?: Y.Doc;
  awareness?: WebsocketProvider['awareness'];
  editors?: WebsocketAwarenessState[];
  isYjsDirty?: boolean;
}

export const WebsocketContext = createContext<WebsocketContextProps>({});

export default WebsocketContext;
